import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  // If returning from OAuth, let AuthCallback run instead of redirecting
  if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
    return null;
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-[#F7F5F0] grid place-items-center">
        <div className="w-10 h-10 rounded-full border-2 border-navy border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}
